import * as React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: "1px dashed #484848",
      opacity: 0.28,
      height: "0px",
      margin: theme.spacing(0.5, 0, 1, 1),
    },
  })
);

function DottedLine() {
  const classes = useStyles();

  return <div className={classes.root} />;
}

export default DottedLine;
